import React from 'react'
import TeacherCard from '../../../Components/TeacherCard'
import MegaNavbar from '../../../Components/MegaNavbar'
import Footer from '../../../Components/Footer'
import DrZainab from '../../../assets/F_Social_science_Cv/Islamiyat/CV of Dr. Zainab Amin.pdf'
import DrFatima_CV from '../../../assets/F_Social_science_Cv/Islamiyat/DrFatima_CV.pdf'
import DrHashmat_CV from'../../../assets/F_Social_science_Cv/Islamiyat/DrHashmat_CV.pdf'

import SadiaNazeer_Cv from '../../../assets/F_Social_science_Cv/English/Sadia_Nazeer_cv.pdf'

const English = () => {
  return (
    <>
    <MegaNavbar/>
      
      <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Islamiyat</h2>
        
        <p>Faculty of Islamiyat.</p>
      </div>

      <div className="row">

      <TeacherCard
      name='Dr. Zainab Amin  '
      profile_name='Associate Professor Department of Islamic Studies'
      intro='Chairperson HEC Approved Supervisor  Department of Islamic Studies Shaheed Benazir Bhutto Women University Peshawar'
      email='zainabrauf@sbbwu.edu.pk'
      cv={DrZainab}
      google='https://www.google.com/'
      linkedin=''/>
   
      <TeacherCard
      name='Dr. Fatima'
      profile_name='Lecturer, Department of  Islamic studies'
      intro='Lecturer, Department of Islamic studies Shaheed Benazir Bhutto Women University, Peshawar'
      email='fatimasaba@sbbwu.edu.pk '
      cv={DrFatima_CV}
      google='https://www.google.com/'
      linkedin=''/>
   
      <TeacherCard
      name='Dr. Hashmat Begum '
      profile_name='Associate Professor Department of Islamic studies'
      intro='HEC Approved Supervisor Department of Islamic studies Shaheed Benazir Bhutto Women University Peshawar'
      email='hashmat.begum@sbbwu.edu.pk '
      cv={DrHashmat_CV}
      google='https://www.google.com/'
      linkedin=''/>
   
      
   
       
        
        

        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>



      <Footer/>
    </>
  )
}

export default English
